import { AfterContentChecked, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../services/login.service';
import { HomeService } from '../shared/services/home.service';
import { SidePanelService } from '../shared/services/side-pannel/side-pannel.service';
import { RecruiterServices } from '../shared/services/recruiter.services';
import { ReportService } from '../repository/service/report.service';
import { FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { MatSidenav } from '@angular/material/sidenav';
export interface State {
  name: string;
  url: string;
  type: string;
}

@Component({
  selector: 'app-topline',
  templateUrl: './topline.component.html',
  styleUrls: ['./topline.component.scss']
})
export class ToplineComponent implements OnInit, AfterContentChecked {
  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;


  accessRoles: any;
  openSidenav2: boolean = false;
  urlParams: string = 'not present';
  studyId: string;
  linkRoute: string;
  visibilityCheck: boolean = false;
  public performaceTracker: boolean = false;
  public funnelReport: boolean = false;
  public panelList: boolean = false;
  public biReport: boolean = false;
  public isLoading: boolean = false;
  public isReport: boolean = false;
  public showsidenav: string = "show";
  keyData: string = '';

  @ViewChild('sidenav2', {static: false}) sidenav2: MatSidenav;
  constructor(public router: Router,
    private activatedRoute: ActivatedRoute,
    private LogoutService: LoginService,
    public homeService: HomeService,
    public sidePanelService:SidePanelService,
    private recruiterServices: RecruiterServices,
    public reportService:ReportService) { 
    this.handleHomeComponetLoad();
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((query) => {
      this.keyData = '';
      if (query.key) {
        this.keyData = query.key;
        this.stateCtrl.setValue(this.keyData);
      } else {
        this.stateCtrl.setValue(this.keyData);
        this.filteredStates = null;
      }
    });

    this.activatedRoute.url.subscribe(() => {
      this.isReport = this.router.url.indexOf('report') > -1 && this.router.url.indexOf('bi-report') == -1 ? true : false;
    });

    if (this.router.url.split('/')[2]) {
      this.urlParams = this.router.url.split('/')[2];
    }
    this.stateCtrl.valueChanges.subscribe(keyword => {
      if (keyword.length < 2) {
      }
      if (keyword.length > 2) {
        this.recruiterServices.getGlobalSearch(keyword).subscribe(data => {
          if (data.result)
            this.filteredStates = of(data.result);
        });
      }
    });
  }

  ngAfterContentChecked() {
    this.performaceTracker = false;
    this.panelList = false;
    this.biReport = false;
    this.funnelReport = false;
    if (localStorage.getItem('performaceTracker') == 'true')
      this.performaceTracker = true;

    if (localStorage.getItem('panelList') == 'true')
      this.panelList = true;

    if (localStorage.getItem('biReport') == 'true')
      this.biReport = true;

    if (localStorage.getItem('funnelReport') == 'true')
      this.funnelReport = true;

    if (this.accessRoles && this.accessRoles.super == true) {
      this.performaceTracker = true;
      this.panelList = true;
      this.funnelReport = true;
      this.biReport = true;
    }

    if (this.router.url === "/home/recruiters") {
      //  this.homeService.sidenav2Open.next(false);
    }

  }

  handleHomeComponetLoad() {

    // For survey panel, If home/survey not exist in url, it will now hamper side tree or side panel
    this.homeService.isUserLoggedIn = true;
    this.homeService.isSurveyOnMobile = false;
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
    if(this.router.url.includes('/home/survey/')) {
      if(this.homeService.isMobileDevice()) {
        this.homeService.isSurveyOnMobile = true;
      }
      if(!this.accessRoles) {
        this.homeService.isUserLoggedIn = false;
        return;
      }
    }
    // survey panel end

    this.homeService.sidenav2Open.subscribe((status) => {
      this.homeService.hardCodeRepo = true;
      this.openSidenav2 = status;
    });
    this.studyId = this.router.url.split('/')[this.router.url.split('/').length - 1];
    this.sidePanelService.initSideDrawer('home');
  }

  navigateToSurveyBuilder() {
    this.isLoading = true;
    this.router.navigate(['/surveys/listing']);
  }

  changeToElip(str: string): string {
    if (str.length > 32) {
      str = str.slice(0, 32) + '...';
    }
    return str;
  }

  onMenuItemClick(menuItem: string) {
    this.homeService.hardCodeRepo = true;
    this.studyId = this.router.url.split('/')[this.router.url.split('/').length - 1];
    switch (menuItem) {
      case 'projects':
        this.sidenav2.close();
        this.router.navigate(['/home/projects']);
        break;
      case 'contributors':
        this.sidenav2.close();
        this.router.navigate(['/home/contributors']);
        break;
      case 'manage':
        this.sidenav2.close();
        this.router.navigate(['/home/recruiters']);
        break;
      case 'dashboard':
        this.sidenav2.close();
        this.router.navigate(['/home/dashboard']);
        break;
      case 'performance':
        this.router.navigateByUrl('/home/performance-tracker/' + this.studyId);
        break;
      case 'bi':
        this.router.navigateByUrl('/home/bi-report/' + this.studyId);
        break;
      case 'funnel':
        this.router.navigateByUrl('/home/funnel-report/' + this.studyId);
        break;
      case 'term':
        this.router.navigateByUrl('/home/term-report/' + this.studyId);
        break;
      case 'utm':
        this.router.navigateByUrl('/home/utm-report/' + this.studyId);
        break;
      case 'summary':
        this.router.navigateByUrl('/home/summary-report/' + this.studyId);
        break;
      case 'recruiters':
        this.router.navigateByUrl('/home/projects/dashboard/' + this.studyId);
        break;
      case 'panel':
        this.router.navigateByUrl('/home/panel-list/' + this.studyId);
        break;
      case 'visibility':
        this.router.navigateByUrl('/home/visibility/' + this.studyId);
        break;
      case 'survey':
        this.router.navigate(['/surveys/listing']);
        break;
      case 'eagle-live':
        this.router.navigate(['/eagle-live/dashboard']);
        break;
      case 'consumer-immersions':
        this.router.navigate(['/consumer-immersions/request-list']);
        break;
      case 'user-list':
        this.sidenav2.close();
        this.router.navigate(['/home/user-list']);
        break;
      case 'team-list':
        this.sidenav2.close();
        this.router.navigate(['/home/team-list']);
        break;
      case 'repository-report':
        this.homeService.hardCodeRepo = false;
        this.router.navigate(['/home/repository-report']);
        break;
      default:
        this.sidenav2.close();
        this.router.navigate(['/login']);
    }
  }
  navigateToDashboard() {
    this.router.navigate(['/home/dashboard']);
  }
  openNewTab() {
    window.open('https://eagleinsights.in');
  }

  logout() {
    this.LogoutService.logout().subscribe(data => {
    });
    this.router.navigate(['/login']);
  }
  
  gotoSearchpage(type, id, keyName) {

    let gloableSearch = 0;
    let url: string;

    if (type == "project") {
      url = '/home/projects/' + id;
      window.location.href = url + '/?key=' + keyName;

    } else if (type == "study") {

      url = '/home/performance-tracker/' + id;
      window.location.href = url + '/?key=' + keyName;

    } else if (type == "recruiter") {
      let url = "/home/recruiters";
      gloableSearch = 1;
      // window.location.href=url + '/?key='+keyName + '&gloableSearch=' + gloableSearch + '&id=' + id;
      this.router.navigate([url], { queryParams: { gloableSearch: gloableSearch, id: id } });
    } 

  }

  switchReport() {
    this.isReport = !this.isReport;
  }

  goToLoginPage() {
    this.homeService.guestLoginClickEvent.emit();
    this.router.navigate(['/login']);
  }
  openSidenav(){
    if(this.sidePanelService.sideDrawer && this.sidePanelService.sideDrawer.subMenu && this.sidePanelService.sideDrawer.subMenu.length > 0){
      this.homeService.openSidenav();
    }
  }
}
